import React from 'react'
import { Typography } from '@material-ui/core'
import { injectIntl } from 'react-intl'
import 'styles/app/inner-layout.scss'
import CardsGrid from 'components/common/CardsGrid/CardsGrid'
import messages from '../translate'

function AppsLayout({ intl: { formatMessage }, appList }) {
  return (
    <div className="preview">
      <div className="module-head">
        <Typography className="module-title" variant="h5">
          {formatMessage(messages.appsStore)}
        </Typography>
      </div>
      <div className="preview-content apps-content">
        <CardsGrid cards={appList} />
      </div>
    </div>
  )
}

export default injectIntl(AppsLayout)
